import { CourseDetailsActions } from "./CourseDetails-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

export const fetchPageData = (url_data, token) => {
	// console.log("**************************************")
	// console.log(url_data)
	return async (dispatch) => {
		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const pageData = await fetchData();
			dispatch(CourseDetailsActions.updatePageData(pageData));
		} catch (error) {
			console.log(error);
		}
	};
};
